import React from "react";
import * as Yup from 'yup';
import { useFormik } from "formik";
import { Alert, Button, Card, Col, Container, Form, Row, Spinner } from "react-bootstrap";

import { useSubmitStoreContactMessageMutation } from "../../redux/services/store/storeContactApi";

const contactDetails = [
    {
        id: 1,
        color: "primary",
        icon: "bi bi-geo-alt-fill",
        title: "Main Store Address",
        describe:
            "FIONA ZIYABRIDAL STUDIO PRIVATE LIMITED, CHUNDHIRAM PARAMBIL, FIYONA ZIA, PETTA SCHOOL, Kanjirapally, Kanjirappally, Kottayam - 686507, Kerala",
    },
    {
        id: 2,
        color: "secondary",
        icon: "bi bi-telephone-fill",
        title: "Phone Number",
        describe: "+91 70348 95342 +91 97787 59369",
    },
    {
        id: 3,
        color: "danger",
        icon: "bi bi-envelope-fill",
        title: "Email",
        describe: "support@FionaZiya.in",
    },
    {
        id: 4,
        color: "success",
        icon: "bi bi-map-fill",
        title: "Map Location",
        describe: "https://maps.app.goo.gl/WZf8s7JNyhvanmnJ7",
        href: "https://maps.app.goo.gl/WZf8s7JNyhvanmnJ7",
    },
];

const ContactUs = () => {
    const [submitContactMessage, { isLoading }] = useSubmitStoreContactMessageMutation();
    const [submitError, setSubmitError] = React.useState<string | null>(null);
    const [submitSuccess, setSubmitSuccess] = React.useState<string | null>(null);

    const formik = useFormik({
        initialValues: {
            name: "",
            email: "",
            phone: "",
            subject: "",
            message: "",
        },
        validationSchema: Yup.object({
            name: Yup.string().required('Please Enter Your Name'),
            email: Yup.string()
                .trim()
                .email("Please Enter Valid Email")
                .matches(/^(?!.*@[^,]*,)/, { excludeEmptyString: true })
                .test(
                    "email-or-phone",
                    "Please enter email or phone number",
                    function (value) {
                        const phone = (this.parent.phone || "").trim();
                        if (phone) return true;
                        return Boolean((value || "").trim());
                    }
                ),
            phone: Yup.string()
                .trim()
                .test(
                    "email-or-phone",
                    "Please enter phone number or email",
                    function (value) {
                        const email = (this.parent.email || "").trim();
                        if (email) return true;
                        return Boolean((value || "").trim());
                    }
                ),
            subject: Yup.string().required('Please Enter Your Subject'),
            message: Yup.string().required("Please Enter Your some message")
        }),
        onSubmit: async (values, helpers) => {
            setSubmitError(null);
            setSubmitSuccess(null);
            try {
                const res = await submitContactMessage({
                    full_name: values.name.trim(),
                    email: values.email.trim() || null,
                    phone: values.phone.trim() || null,
                    subject: values.subject.trim() || null,
                    message: values.message.trim(),
                    source_page: "contact_us",
                }).unwrap();
                setSubmitSuccess(res.message || "Your message has been sent successfully");
                helpers.resetForm();
            } catch (err: any) {
                const detail = err?.data?.detail;
                setSubmitError(
                    typeof detail === "string"
                        ? detail
                        : detail?.message || err?.error || "Failed to send your message"
                );
            }
        },
    });

    return (
        <React.Fragment>
            <section className="ecommerce-about bg-primary">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={5}>
                            <div className="text-center">
                                <h1 className="text-white">Contact Us</h1>
                                <p className="fs-16 mb-0 text-white-75">Let's start something great together. Get in touch with one of the team today!</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section className="section">
                <Container>
                    <Row>
                        <Col lg={4}>
                            {
                                (contactDetails || [])?.map((item, idx) => {
                                    return (
                                        <Card key={idx} className="border border-opacity-25">
                                            <Card.Body className="p-4">
                                                <div className="d-flex">
                                                    <div className="avatar-sm flex-shrink-0">
                                                        <div className={`avatar-title bg-${item.color}-subtle text-${item.color} rounded fs-17`}>
                                                            <i className={`${item.icon}`}></i>
                                                        </div>
                                                    </div>
                                                    <div className="ms-3 flex-grow-1">
                                                        <h5 className="fs-17 lh-base mb-2">{item.title}</h5>
                                                        {item.href ? (
                                                            <a
                                                                href={item.href}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                                className="text-muted fs-14 mb-0 d-inline-block"
                                                            >
                                                                Open Map
                                                            </a>
                                                        ) : (
                                                            <p className="text-muted fs-14 mb-0">{item.describe}</p>
                                                        )}
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    )
                                })
                            }
                        </Col>

                        <Col lg={8}>
                            <div className="custom-form card p-4 p-lg-5">
                                <Form name="myForm" onSubmit={formik.handleSubmit}>
                                    <Row>
                                        <Col lg={12}>
                                            <div className="text-center mb-4">
                                                <h3 className="text-capitalize">Get In Touch with us for more Information</h3>
                                            </div>
                                        </Col>
                                        {submitSuccess ? (
                                            <Col lg={12}>
                                                <Alert variant="success">{submitSuccess}</Alert>
                                            </Col>
                                        ) : null}
                                        {submitError ? (
                                            <Col lg={12}>
                                                <Alert variant="danger">{submitError}</Alert>
                                            </Col>
                                        ) : null}
                                        <Col lgt={6}>
                                            <div className="form-group mt-3">
                                                <Form.Label htmlFor="nameInput">Name<span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    name="name"
                                                    id="nameInput"
                                                    type="text"
                                                    placeholder="Enter name"
                                                    value={formik.values.name}
                                                    onBlur={formik.handleBlur}
                                                    onChange={formik.handleChange} />
                                                {
                                                    formik.errors.name && formik.touched.name ? (
                                                        <span className="text-danger">{formik.errors.name}</span>
                                                    ) : null
                                                }
                                            </div>
                                        </Col>
                                        <Col lg={6}>
                                            <div className="form-group mt-3">
                                                <Form.Label htmlFor="emailInput">Email</Form.Label>
                                                <Form.Control
                                                    name="email"
                                                    id="emailInput"
                                                    type="email"
                                                    placeholder="Enter email"
                                                    value={formik.values.email}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                                {
                                                    formik.errors.email && formik.touched.email ? (
                                                        <span className="text-danger">{formik.errors.email}</span>
                                                    ) : null
                                                }
                                            </div>
                                        </Col>
                                        <Col lg={6}>
                                            <div className="form-group mt-3">
                                                <Form.Label htmlFor="phoneInput">Phone</Form.Label>
                                                <Form.Control
                                                    name="phone"
                                                    id="phoneInput"
                                                    type="text"
                                                    placeholder="Enter phone number"
                                                    value={formik.values.phone}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                                {
                                                    formik.errors.phone && formik.touched.phone ? (
                                                        <span className="text-danger">{formik.errors.phone}</span>
                                                    ) : null
                                                }
                                            </div>
                                        </Col>
                                        <Col lg={12}>
                                            <div className="form-group mt-3">
                                                <Form.Label htmlFor="subjectInput">Subject<span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    id="subjectInput"
                                                    placeholder="Enter Subject.."
                                                    name="subject"
                                                    value={formik.values.subject}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                                {
                                                    formik.errors.subject && formik.touched.subject ? (
                                                        <span className="text-danger">{formik.errors.subject}</span>
                                                    ) : null
                                                }
                                            </div>
                                        </Col>
                                        <Col lg={12}>
                                            <div className="form-group mt-3">
                                                <Form.Label htmlFor="messageInput">Message<span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    name="message"
                                                    id="messageInput"
                                                    rows={4}
                                                    placeholder="Enter message..."
                                                    value={formik.values.message}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                                {
                                                    formik.errors.message && formik.touched.message ? (
                                                        <span className="text-danger">{formik.errors.message}</span>
                                                    ) : null
                                                }
                                            </div>
                                        </Col>
                                        <Col lg={12}>
                                            <div className="text-muted small mt-2">
                                                Enter email or phone number. At least one contact method is required.
                                            </div>
                                        </Col>
                                        <Col lg={12}>
                                            <div className="text-end mt-4">
                                                <Button type="submit" id="submit" name="submit" variant="primary" disabled={isLoading}>
                                                    {isLoading ? (
                                                        <>
                                                            <Spinner size="sm" animation="border" className="me-2" />
                                                            Sending...
                                                        </>
                                                    ) : (
                                                        <>
                                                            Send Message <i className="bi bi-arrow-right-short align-middle fs-16 ms-1"></i>
                                                        </>
                                                    )}
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section >
            <section>
                <Container fluid className="px-0">
                    <Row className="g-0">
                        <Col lg={12}>
                            <div className="map">
                                <iframe
                                    title="map"
                                    src="https://www.google.com/maps?q=FIONA%20ZIYABRIDAL%20STUDIO%20PRIVATE%20LIMITED%2C%20CHUNDHIRAM%20PARAMBIL%2C%20FIYONA%20ZIA%2C%20PETTA%20SCHOOL%2C%20Kanjirapally%2C%20Kanjirappally%2C%20Kottayam%20686507%2C%20Kerala&z=16&output=embed"
                                    className="w-100"
                                    height="400"
                                    style={{ border: 0 }}
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment >
    )
}

export default ContactUs;
